module.exports = __webpack_public_path__ + "img/icon_img_09.51615c80.png";